import { render, staticRenderFns } from "./PrimarySchoolEnglish1.vue?vue&type=template&id=77749de9&scoped=true&"
import script from "./PrimarySchoolEnglish1.vue?vue&type=script&lang=js&"
export * from "./PrimarySchoolEnglish1.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./PrimarySchoolEnglish1.vue?vue&type=style&index=1&id=77749de9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77749de9",
  null
  
)

export default component.exports